import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import CustomLink from "../elements/CustomLink";
import { FaChevronDown } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool,
};

const defaultProps = {
  navPosition: "",
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false,
};

const isActivePath = (pathname, target) => {
  return pathname.endsWith(target);
};

const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {
  const [isActive, setIsactive] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleDropdown = () => setIsOpen(!isOpen);

  const nav = useRef(null);
  const hamburger = useRef(null);

  useEffect(() => {
    isActive && openMenu();
    document.addEventListener("keydown", keyPress);
    document.addEventListener("click", clickOutside);
    return () => {
      document.removeEventListener("keydown", keyPress);
      document.addEventListener("click", clickOutside);
      closeMenu();
    };
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (nav.current && !nav.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openMenu = () => {
    document.body.classList.add("off-nav-is-active");
    nav.current.style.maxHeight = nav.current.scrollHeight + "px";
    setIsactive(true);
  };

  const closeMenu = () => {
    document.body.classList.remove("off-nav-is-active");
    nav.current && (nav.current.style.maxHeight = null);
    setIsactive(false);
  };

  const keyPress = (e) => {
    isActive && e.keyCode === 27 && closeMenu();
  };

  const clickOutside = (e) => {
    if (!nav.current) return;
    if (
      !isActive ||
      nav.current.contains(e.target) ||
      e.target === hamburger.current
    )
      return;
    closeMenu();
  };

  const classes = classNames(
    "site-header",
    bottomOuterDivider && "has-bottom-divider",
    className,
  );

  return (
    <header {...props} className={classes}>
      <div className="container">
        <div
          className={classNames(
            "site-header-inner",
            bottomDivider && "has-bottom-divider",
          )}
        >
          {/* <Logo /> */}
          {!hideNav && (
            <>
              <button
                ref={hamburger}
                className="header-nav-toggle"
                onClick={isActive ? closeMenu : openMenu}
              >
                <span className="screen-reader">Menu</span>
                <span className="hamburger">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <nav
                ref={nav}
                className={classNames("header-nav", isActive && "is-active")}
              >
                <div className="header-nav-inner">
                  <ul
                    className={classNames(
                      "list-reset text-xs",
                      navPosition && `header-nav-${navPosition}`,
                    )}
                  >
                    <li>
                      <CustomLink to="/" onClick={closeMenu}>
                        <span
                          style={
                            isActivePath(location.pathname, "/")
                              ? {
                                  textDecoration: "underline",
                                  textDecorationThickness: "2px",
                                  textUnderlineOffset: "4px",
                                }
                              : {}
                          }
                        >
                          Home
                        </span>
                      </CustomLink>
                    </li>
                    <li>
                      <CustomLink to="/why-drives" onClick={closeMenu}>
                        <span
                          style={
                            isActivePath(location.pathname, "/why-drives")
                              ? {
                                  textDecoration: "underline",
                                  textDecorationThickness: "2px",
                                  textUnderlineOffset: "4px",
                                }
                              : {}
                          }
                        >
                          Why Drives
                        </span>
                      </CustomLink>
                    </li>
                    <li>
                      <CustomLink to="/drives-score" onClick={closeMenu}>
                        <span
                          style={
                            isActivePath(location.pathname, "/drives-score")
                              ? {
                                  textDecoration: "underline",
                                  textDecorationThickness: "2px",
                                  textUnderlineOffset: "4px",
                                }
                              : {}
                          }
                        >
                          Drives Score
                        </span>
                        <sup
                          className="text-gold"
                          style={{
                            paddingLeft: "1px",
                            fontSize: "0.6em",
                            fontWeight: "bold",
                            verticalAlign: "super",
                            textDecoration: "none",
                          }}
                        >
                          TM
                        </sup>
                      </CustomLink>
                    </li>
                    <li className="dropdown pt-2 pb-1 sm:pb-0 sm:pt-0 lg:pl-5">
                      <div
                        onClick={toggleDropdown}
                        className="dropdown-toggle flex items-center justify-center gap-1 text-gold header-nav text-xs font-normal"
                        style={{
                          textDecoration: [
                            "/american-football",
                            "/baseball",
                            "/golf",
                            "/drivesfi",
                          ].some((path) =>
                            isActivePath(location.pathname, path),
                          )
                            ? "underline"
                            : "none",
                          textDecorationThickness: "2px",
                          textUnderlineOffset: "4px",
                        }}
                      >
                        Products
                        <FaChevronDown
                          className={`w-3 h-3 dropdown-icon transform transition-transform duration-300 ${
                            isOpen ? "open rotate-180" : ""
                          }`}
                        />
                      </div>
                      {isOpen && (
                        <ul className="list-none dropdown-menu lg:mt-5 bg-transparent  sm:bg-[#212129] p-0">
                          <li className="p-0">
                            <CustomLink
                              to="/american-football"
                              onClick={() => {
                                toggleDropdown();
                                closeMenu();
                              }}
                            >
                              <span
                                style={
                                  isActivePath(
                                    location.pathname,
                                    "/american-football",
                                  )
                                    ? {
                                        textDecoration: "underline",
                                        textDecorationThickness: "2px",
                                        textUnderlineOffset: "4px",
                                      }
                                    : {}
                                }
                              >
                                Football
                              </span>
                            </CustomLink>
                          </li>
                          <li>
                            <CustomLink
                              to="/baseball"
                              onClick={() => {
                                toggleDropdown();
                                closeMenu();
                              }}
                            >
                              <span
                                style={
                                  isActivePath(location.pathname, "/baseball")
                                    ? {
                                        textDecoration: "underline",
                                        textDecorationThickness: "2px",
                                        textUnderlineOffset: "4px",
                                      }
                                    : {}
                                }
                              >
                                Baseball
                              </span>
                            </CustomLink>
                          </li>
                          <li className="w-full">
                            <CustomLink
                              to="/golf"
                              onClick={() => {
                                toggleDropdown();
                                closeMenu();
                              }}
                            >
                              <span
                                style={
                                  isActivePath(location.pathname, "/golf")
                                    ? {
                                        textDecoration: "underline",
                                        textDecorationThickness: "2px",
                                        textUnderlineOffset: "4px",
                                      }
                                    : {}
                                }
                              >
                                Golf
                              </span>
                            </CustomLink>
                          </li>
                          <li className="w-full">
                            <CustomLink
                              to="/drivesfi"
                              onClick={() => {
                                toggleDropdown();
                                closeMenu();
                              }}
                            >
                              <span
                                style={
                                  isActivePath(location.pathname, "/drivesfi")
                                    ? {
                                        textDecoration: "underline",
                                        textDecorationThickness: "2px",
                                        textUnderlineOffset: "4px",
                                      }
                                    : {}
                                }
                              >
                                DrivesFi
                              </span>
                            </CustomLink>
                          </li>
                        </ul>
                      )}
                    </li>
                    <li>
                      <CustomLink to="/about" onClick={closeMenu}>
                        <span
                          style={
                            isActivePath(location.pathname, "/about")
                              ? {
                                  textDecoration: "underline",
                                  textDecorationThickness: "2px",
                                  textUnderlineOffset: "4px",
                                }
                              : {}
                          }
                        >
                          About
                        </span>
                      </CustomLink>
                    </li>
                  </ul>
                  <ul className="list-reset header-nav-right"></ul>
                </div>
              </nav>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
